//import './App.css';
import "bootstrap/dist/css/bootstrap.css";
import "./styles/style.scss";

import Home from "./pages/Home";

function App() {
  return (
    <div className="App" id="app">
      <Home />
    </div>
  );
}

export default App;
